<template>
	<div class="atividadecadastro">
	  <loader object="#df3e46" v-show="progress>0" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
	  <div class="container">
		<ol class="breadcrumb-arrow">
		  <li>
			<a href="/home"><i class="fa fa-home"></i></a>
			<a href="/atividade-listagem">Atividades</a>
		  </li>
		  <li>
			<a href="#">{{title}}</a>
		  </li>
		</ol>
	  </div>
  
		<div class="container mt-2">
			<!--
			<div class="row ml-0 mr-0 page-header-title">
				<div class="col-lg-12 col-sm-12 pr-0 pl-0 d-none d-sm-block d-lg-block d-xl-block">
					<h2 class="text-header txt-bloqueio">Atividade</h2>
				</div>
			</div>	
			-->
			<div>
				<form class="ml-3 mt-3 mr-3 mb-3">
					<div class="col-md-12">

						<div class="row d-flex justify-content-center">

							<div class="col-8">

								<label for="inputTitulo">
									Nome da Atividade
									<el-tooltip content="Campo obrigatório" placement="top">
										<i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
									</el-tooltip>
								</label>
								<div class="input-group">
									<div class="input-group-prepend mb-2">
										<span class="input-group-text"><i class="fas fa-align-left"></i></span>
									</div>
									<input
										id="inputTitulo"
										maxlength="500"
										tabindex="1"
										type="text"
										class="form-control mb-2"
										v-model="atividade.titulo"
										placeholder="Informe o nome da Atividade"
									/>
								</div>

								<label for="inputProjeto">
									Projeto
									<el-tooltip content="Campo obrigatório" placement="top">
										<i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
									</el-tooltip>
								</label>
								<div class="input-group">
									<div class="input-group-prepend mb-2">
										<span class="input-group-text"><i class="fas fa-align-left"></i></span>
									</div>
									<v-select
										class="campoMultiploProjeto mb-2"
										placeholder="Selecione um Projeto"
										label="codigoNome"
										v-model="projeto"
										@input="limitarPeriodoPorProjeto"
										:options="listaProjetos">
										<template v-slot:option="option">
											{{ option.codigoNome }} ({{option.situacaoDescricao}})
										</template>                                 
										<span slot="no-options" @click="$refs.select.open = false">
											Nenhum registro encontrado
										</span>
									</v-select>
								</div>

								<div class="row">
									<div class="col-8">

										<label for="inputData">
											Período
											<el-tooltip content="Campo obrigatório" placement="top"
												><i
												style="font-size: 12px"
												class="fas fa-exclamation-circle text-info ml-1"
												></i
											></el-tooltip>
										</label>
										<div class="input-group">
											<div class="input-group-prepend mb-2">
												<span class="input-group-text">
													<i class="far fa-calendar-alt"></i>
												</span>
											</div>
											<flat-picker
												value=""
												tabindex="3"
												id="dataInicio"
												class="form-control datepicker mb-2"
												placeholder="Data Início"
												v-model="atividade.dataInicio"
												:disabled="projeto==null || projeto.dataInicio==null"
												:config="{
													allowInput: true,
													minDate: projeto != null && projeto.dataInicio,
													maxDate: projeto != null && projeto.dataFim,
													dateFormat: 'd/m/Y',
													altFormat: 'M j, Y',
												}"/>
											<span class="m-2">até</span>
											<div class="input-group-prepend mb-2">
												<span class="input-group-text"
												><i class="far fa-calendar-alt"></i
												></span>
											</div>
											<flat-picker
												value=""
												id="dataFim"
												tabindex="4"
												class="form-control datepicker mb-2"
												placeholder="Data fim"
												:disabled="projeto==null || projeto.dataFim==null"
												v-model="atividade.dataFim"
												:config="{
													allowInput: true,
													minDate: atividade.dataInicio,
													maxDate: projeto != null && projeto.dataFim,
													dateFormat: 'd/m/Y',
													altFormat: 'M j, Y',
												}"
											/>
										</div>
									</div>
									<div class="col-4">

										<label for="inputDestaque">
											Destaque
										</label>
										<div class="input-group">
											<div class="input-group-prepend mb-2">
												<span class="input-group-text pt-2 pb-2">
												<i v-show="atividade.destaque" style="color: #d4b818" class="fas fa-star"></i>
												<i v-show="!atividade.destaque" class="far fa-star"></i>
											</span>
											</div>   
											<div class="col-2 custom-switch ml-2 mt-1 campoForm">
												<input type="checkbox" 
													tabindex="5" v-model="atividade.destaque"
													class="custom-control-input"
													id="check3"/>
												<label class="custom-control-label" v-show="!atividade.destaque" for="check3">Não</label>
												<label class="custom-control-label" v-show="atividade.destaque" for="check3">Sim</label>
											</div>
										</div>

									</div>
								</div>

								<div class="row">
									<div class="col">

										<label for="recursoEmpenhado">
											Recurso Empenhado
										</label>
										<div class="row">
											<div class="col input-group">
												<div class="input-group-prepend mr-n1">
													<span class="input-group-text pt-2 pb-2" style="background-color: #dbffd6;">
														<i class="fas fa-money-bill-alt mr-1"></i
													></span>
												</div>
												<vue-numeric
													label="Valor"
													tabindex="7"
													name="Recurso Empenhado"
													id="recursoEmpenhado"
													placeholder="Valor"
													class="form-control"
													v-model="atividade.investimento"
													separator="."
													v-bind:precision="2"
													v-bind:minus="false">
												</vue-numeric>
											</div>
										</div>

									</div>
									<div class="col">

										<label for="recursoNaoEmpenhado">
											Recurso Não Empenhado
										</label>
										<div class="row">
											<div class="col input-group">
												<div class="input-group-prepend mr-n1">
													<span class="input-group-text pt-2 pb-2" style="background-color: #fffaaa;">
														<i class="fas fa-money-bill-alt mr-1"></i
													></span>
												</div>
												<vue-numeric
													label="Valor"
													tabindex="7"
													name="Recurso Não Empenhado"
													id="recursoNaoEmpenhado"
													placeholder="Valor"
													class="form-control"
													v-model="atividade.investimentoNaoEmpenho"
													separator="."
													v-bind:precision="2"
													v-bind:minus="false">
												</vue-numeric>
											</div>
										</div>

									</div>
								</div>
								<div class="row">
									<div class="col">

										<label for="inputResponsavel">
											Responsável
											<el-tooltip content="Campo obrigatório" placement="top">
												<i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
											</el-tooltip>
										</label>
										<div class="input-group">
											<div class="input-group-prepend mb-2">
												<span class="input-group-text py-2"><i class="fas fa-user-alt"></i></span>
											</div>
											<v-select v-if="!atividade.idatividade"
												class="campoMultiplo mb-2"
												placeholder="Selecione um Responsável"
												label="nome"
												multiple
												:reduce="(u) => u.idusuario"
												v-model="atividade.idsResponsavel"
												:options="listaResponsaveis">
												<span slot="no-options" @click="$refs.select.open = false">
													Nenhum registro encontrado
												</span>
											</v-select>

											<v-select v-if="atividade.idatividade"
												class="campoMultiplo mb-2"
												placeholder="Selecione um Responsável"
												label="nome"
												multiple
												:reduce="(u) => u.idusuario"
												v-model="atividade.listaResponsavel"
												:options="listaResponsaveis">
												<span slot="no-options" @click="$refs.select.open = false">
													Nenhum registro encontrado
												</span>
											</v-select>
										</div>

									</div>
									<div class="col">

										<label for="inputTipo">
											Tipo da Atividade
											<el-tooltip content="Campo obrigatório" placement="top">
												<i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
											</el-tooltip>
										</label>
										<div class="input-group">
											<div class="input-group-prepend mb-2">
												<span class="input-group-text"><i class="fas fa-clipboard-list"></i></span>
											</div>
											<v-select v-if="!atividade.idatividade"
												class="campoMultiploTipo mb-2"
												placeholder="Selecione um Tipo de Atividade"
												label="nome"
												:reduce="(u) => u.idsubtipoatividade"
												v-model="atividade.idSubtipoAtividade"
												:options="listaTipos">
												<span slot="no-options" @click="$refs.select.open = false">
													Nenhum registro encontrado
												</span>
											</v-select>

											<v-select v-if="atividade.idatividade"
												class="campoMultiploTipo mb-2"
												placeholder="Selecione um Tipo de Atividade"
												label="nome"
												:reduce="(u) => u.idsubtipoatividade"
												v-model="atividade.subtipoAtividade.idsubtipoatividade"
												:options="listaTipos">
												<span slot="no-options" @click="$refs.select.open = false">
													Nenhum registro encontrado
												</span>
											</v-select>

										</div>

									</div>
								</div>
							</div>
						</div>

						<div class="steps-action w-100 text-center">
							<el-tooltip
								style="margin-left: 8px"
								content="Desistir do cadastro da atividade"
								placement="top">
								<span>
									<button
										type="button"
										tabindex="9"
										class="btn btn-danger"
										@click="voltar()">
										<i class="fa fa-times"></i>
										<span>Cancelar</span>
									</button>
								</span>
							</el-tooltip>
							<el-tooltip
								style="margin-left: 8px"
								content="Salvar os dados da atividade"
								placement="top">
								<span>
									<button
										type="button"
										tabindex="9"
										class="btn btn-success"
										@click="salvarAtividade()">
										<i class="fas fa-calendar-check mr-2"></i>
										<span v-if="!atividade.idatividade">Cadastrar Atividade</span>
										<span v-if="atividade.idatividade">Alterar Atividade</span>
									</button>
								</span>
							</el-tooltip>
							
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
  </template>
  
  <script>
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import "vue-select/dist/vue-select.css";
  import $ from 'jquery'
  
  export default {
		props: {
			title: {
				type: String
			},
		},
		components: {
			flatPicker,
		},
		created() {
			this.carregarTelaAtividade();
		},
		data() {
			return {
				idatividade: this.$route.params.idatividade,
				idprojeto: this.$route.params.idprojeto,
				progress: 3,
				atividade: {
					titulo: "",
					idprojeto: null,
					dataInicio: null,
					dataFim: null,
					destaque: false,
					idsResponsavel: [],
					investimento: "0,00",
					investimentoNaoEmpenho: "0,00",
					idSubtipoAtividade: null,
					observacao: null,
				},
				projeto: null,
				listaResponsaveis: [],
				listaProjetos: [],
				listaTipos: []
			};
		},
		methods: {
			async carregarTelaAtividade() {
			
				await this.carregarCombosTela();
				// se houver id como parametro, carrega o atividade do id
				if (this.idatividade) {
					this.title = "Alterar"
					this.progress = this.progress + 1;
					this.carregarAtividade(this.idatividade);
				} else {
					this.title = "Incluir"
				}
				//$("#menuAtividade").addClass('router-link-exact-active router-link-active');
			},
			carregarAtividade(idatividade) {
				//this.progress = true;
				this.$clubApi.get("/atividade/"+ idatividade).then((response) => {
					let retorno = response.data.object;
					this.atividade = retorno;
					this.atividade.idSubtipoAtividade = retorno.subtipoAtividade.idsubtipoatividade;
					this.projeto = this.atividade.projeto;
					if (!this.idatividade) {
						this.limitarPeriodoPorProjeto();
					}
				})
				.catch((error) => {
					this.atividade = {};
					this.$toastr.warning(error.response.data.msg);
				})
				.finally(() => {
					//this.progress = false;
					this.progress = this.progress - 1;
				});
			},
			carregarProjeto(idprojeto) {
				this.progress = this.progress + 1;
				this.$clubApi.get("/atividade/projeto/"+ idprojeto).then((response) => {
					this.projeto = response.data.object;
					this.atividade.dataInicio = this.projeto.dataInicio;
					this.atividade.dataFim = this.projeto.dataFim;
					this.atividade.idprojeto = this.projeto.idprojeto;
				})
				.finally(() => {
					this.progress = this.progress - 1;
				});
			},
			carregarCombosTela() {
				var pefil = {
					perfil: localStorage.getItem("trocaPerfil")
				}
				this.$clubApi.post("/atividade/projetos/abertosperfil", pefil).then((response) => {
					this.listaProjetos = response.data.object;
					if (this.idprojeto) {
						this.carregarProjeto(this.idprojeto);
					}
				})
				.catch((error) => {
					this.$toastr.warning(error.response.data.msg);
				})
				.finally(() => {
					this.progress = this.progress - 1;
				});
				this.$clubApi.get("/user/responsaveis").then((response) => {
					this.listaResponsaveis = response.data.object;
				})
				.catch((error) => {
					this.$toastr.warning(error.response.data.msg);
				})
				.finally(() => {
					this.progress = this.progress - 1;
				});
				this.$clubApi.get("/atividade/tipos").then((response) => {
					this.listaTipos = response.data.object;
				})
				.catch((error) => {
					this.$toastr.warning(error.response.data.msg);
				})
				.finally(() => {
					this.progress = this.progress - 1;
				});
			},
			voltar(){
			const options = {
				title: "Cancelar",
				okLabel: "Confirmar",
				cancelLabel: "Não",
			};
			this.$dialogs.confirm('Deseja realmente desistir do cadastro da atividade?', options)
				.then((res) => {
					if (res.ok) {
						location.href = '/atividade-listagem';
					}
				});
			},
			salvarAtividade() {

				if (this.validaInformacoes()) {
					const options = {
						title: "Confirmação",
						okLabel: "Confirmar",
						cancelLabel: "Não",
					};
					let acao = (this.atividade.idatividade) ? "alterar" : "incluir";
					let resposta = (this.atividade.idatividade) ? "alterada" : "incluída";
					if (this.atividade.idatividade){
						
						// Responsável(is) pela atividade
						this.atividade.idsResponsavel = [];
						this.atividade.listaResponsavel.map(resp => {
							if (resp.idusuario) {
								this.atividade.idsResponsavel.push(resp.idusuario);
							} else {
								this.atividade.idsResponsavel.push(resp);
							}
						})
						let idTipoAtividade;
						if(this.atividade.subtipoAtividade.idsubtipoatividade){
							idTipoAtividade = this.atividade.subtipoAtividade.idsubtipoatividade;
						}else{
							idTipoAtividade = this.atividade.subtipoAtividade;
						}
						this.atividade.idSubtipoAtividade = idTipoAtividade;
					}
					this.$dialogs.confirm('Deseja '+ acao +' a atividade "'+ this.atividade.titulo +'"?', options)
						.then((res) => {
							if (res.ok) {
								this.progress = 1;

								this.atividade.idprojeto = this.projeto.idprojeto;
								this.atividade.idPerfil = localStorage.getItem("trocaPerfil")
								if (this.atividade.investimento == "0,00") {
									this.atividade.investimento = 0;
								}
								if (this.atividade.investimentoNaoEmpenho == "0,00") {
									this.atividade.investimentoNaoEmpenho = 0;
								}
								console.log("atividade: ", this.atividade);
								this.$clubApi.post("/atividade", this.atividade).then(() => {
									this.$toastr.success("Atividade "+ resposta +" com sucesso!");
									setTimeout(() => {
										location.href = '/atividade-listagem';
									}, 2000);
								})
								.catch((error) => {
									this.$toastr.error(error.response.data.msg);
								})
								.finally(() => {
									this.progress = 0;
								});
							}
						}); 
				}
			},
			validaInformacoes() {
				var camposValidos = true;
				if (this.atividade.idSubtipoAtividade == null) {
					this.$toastr.error("Tipo da Atividade obrigatório");
					camposValidos = false;
				}
				if (this.atividade.idatividade == null) {
					if (this.atividade.idsResponsavel.length == 0) {
						this.$toastr.error("Responsável obrigatório");
						camposValidos = false;
					}
				} else {
					if (this.atividade.listaResponsavel.length == 0) {
						this.$toastr.error("Responsável obrigatório");
						camposValidos = false;
					}
				}
				if (this.atividade.dataFim == "") {
					this.$toastr.error("Data fim obrigatória!");
					camposValidos = false;
				}
				if (this.atividade.dataInicio == "") {
					this.$toastr.error("Data início obrigatória!");
					camposValidos = false;
				}
				if (this.atividade.idatividade == null) {
					if (this.atividade.idprojeto == null) {
						this.$toastr.error("Projeto obrigatório!");
						camposValidos = false;
					}
				} else {
					if (this.atividade.projeto == null) {
						this.$toastr.error("Projeto obrigatório!");
						camposValidos = false;
					}
				}
				if (this.atividade.titulo == "") {
					this.$toastr.error("Nome da Atividade obrigatório!");
					camposValidos = false;
				}
				return camposValidos;
			},
			limitarPeriodoPorProjeto() {
				if (this.projeto != null) {
					this.atividade.dataInicio = this.projeto.dataInicio;
					this.atividade.dataFim = this.projeto.dataFim;
					this.atividade.idprojeto = this.projeto.idprojeto;
				} else {
					this.atividade.dataInicio = null;
					this.atividade.dataFim = null;
					this.atividade.idprojeto = null;
				}
			}
		},
	};
</script>
<style>

.flatpickr-current-month input.cur-year:hover {
    background: #e9ecef;
    border-radius: 0.375rem;
}
.flatpickr-calendar .flatpickr-current-month span.cur-month, .flatpickr-calendar .flatpickr-current-month input.cur-year {
    padding: 0 10px;
    color: #525f7f;
    font-size: 0.875rem;
    font-weight: 500;
}
.opcao {
	color: #c0c0c0;
	cursor: pointer;
}
.opcao:hover {
	color: red;
	cursor: pointer;
}
.listaGT {
	align-items: center;
	display: flex;
	margin-bottom: 15px;
	padding: 2px;
	height: 40px;
}
.listaGT:hover {
	background-color: #edebfe;
	cursor: pointer;
}
.listaGT:hover .opcao {
	background-color: #edebfe;
	cursor: pointer;
	visibility: visible;
	opacity: 1;
}
.gtInfo {
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;
}
steps-content {
	margin-top: 16px;
	border: 1px dashed #e9e9e9;
	border-radius: 6px;
	background-color: #fafafa;
	min-height: 200px;
	text-align: center;
	padding-top: 80px;
}
.steps-action {
	margin-top: 24px;
}
.campoMultiplo {
	width: 88%;
}
.campoMultiploProjeto {
	width: 94%;
}
.campoMultiploTipo {
	width: 88%;
}
</style>
  
  